import { FormikHelpers } from 'formik/dist/types';

import { ESentFrom } from '../../repositories/e2e-deal-form/entities/availability/LeaveContactsV2RequestSchema';

export interface ILeaveContactsDialogContainerProps {
  /** Модальное окно открыто? */
  isOpen: boolean;
  /** Где вызвано модальное окно */
  calledFrom: ESentFrom;
  /** Заголовок */
  title?: string;
  /** Подзаголовок */
  subtitle?: string;
  /** Сообщение об успешной отправке */
  successMessage?: string;
  /** Сообщение об ошибке во время отправки */
  failMessage?: string;
  /** Дополнительные действия при отправке формы */
  onSendForm?: () => void;
  /** Дополнительные действия при открытии модального окна */
  onOpen?: () => void;
  /** Закрытие модального окна и дополнительные действия при этом */
  onClose: () => void;
}

export interface ILeaveContactsFormValue {
  name: string;
  phone: string;
}

export type TLeaveContactsFormResetHandler = () => void;

export type TLeaveContactsFormSubmitHandler = (
  values: ILeaveContactsFormValue,
  formikHelpers: FormikHelpers<ILeaveContactsFormValue>,
) => Promise<void>;

export enum EFormStatus {
  Pending = 'pending',
  Succeed = 'succeed',
  Failed = 'failed',
}
